import React from "react";
import { HeaderWrapper } from "../styles/components/Global/Global";
import ImageDisplay from "./Image";

const Header = () => {
  return (
    <HeaderWrapper>
      <ImageDisplay src="https://www.datocms-assets.com/40484/1700829331-a-ap-name_distressed_02-1.png" />
    </HeaderWrapper>
  );
};

export default Header;
